/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useCallback, useContext, memo } from 'react';

import initialActions from './actions';

import { IActions } from './dtos';

import { initialState } from './constants';

interface IData {
  data: any;
  actions: IActions;
}

export const SpecSheetSearchContext = React.createContext<IData>({
  data: initialState,
  actions: initialActions({ data: initialState as any, setData: () => {} }),
});

export const useSpecSheetSearch = (): IData =>
  useContext(SpecSheetSearchContext);

export default function withSpecSheetSearchProvider(
  WrappedComponent: React.FC,
  state: any = initialState,
  actions = initialActions,
): React.FC {
  const WithSpecSheetSearch = (props: any) => {
    const [data, setData] = useState(state);

    const value = useCallback(
      () => ({
        data,
        actions: actions({ data, setData }),
      }),
      [data],
    );

    const dataValue: IData = value();

    return (
      <SpecSheetSearchContext.Provider value={dataValue}>
        <WrappedComponent {...props} />
      </SpecSheetSearchContext.Provider>
    );
  };

  return memo(WithSpecSheetSearch);
}
